import React, {useEffect, useState} from 'react';
import './GanttChart.scss';
import DynaSelectBox from "../../../DynaView/DynaSelectBox";
import _axios from "../../../../../httpService";
import {prefixUrl} from "../../../../../utils/utilsData";
import {toast} from "react-toastify";

const GanttChart = ({data, projects, DefaultValues}) => {

  const [sendData, setSendData] = useState({
    projectId: "",
    year: "",
    monthNumber: ""
  })
  const [componentData, setComponentData] = useState([]);

  useEffect(() => {
    setComponentData(data)
    setSendData({...sendData, ...DefaultValues})
  }, []);

  const years = [
    {label: "1403", value: "1403"},
    {label: "1404", value: "1404"},
    {label: "1405", value: "1405"},
    {label: "1406", value: "1406"},
    {label: "1407", value: "1407"},
    {label: "1408", value: "1408"},
    {label: "1409", value: "1409"},
    {label: "1410", value: "1410"},
  ]
  const months = [
    {label: "فروردین", value: "1"},
    {label: "اردیبهشت", value: "2"},
    {label: "خرداد", value: "3"},
    {label: "تیر", value: "4"},
    {label: "مرداد", value: "5"},
    {label: "شهریور", value: "6"},
    {label: "مهر", value: "7"},
    {label: "آبان", value: "8"},
    {label: "آذر", value: "9"},
    {label: "دی", value: "10"},
    {label: "بهمن", value: "11"},
    {label: "اسفند", value: "12"},
  ]

  const filterHandler = async () => {
    const response = await _axios.get(prefixUrl() + `/arkaMonitoring/?request=taskGanttChart&projectId=${sendData?.projectId}&year=${sendData?.year}&monthNumber=${sendData?.monthNumber}`)
    if (response?.data?.status) {
      setComponentData(response?.data?.data)
    } else {
      toast.error(response?.data?.message)
    }
  }

  try {
    return (
      <section className="GanttChart">
        <h5>گانت چارت مدیریت زمان تسک</h5>
        <div className={"row-select-box"}>
          <DynaSelectBox options={projects}
                         hasFilter={false}
                         label={"نام پروژه"}
                         className={"solid-dyna-input"}
                         value={sendData?.projectId.toString()}
                         onChange={(data) => setSendData({...sendData, projectId: data.value})}
          />
          <DynaSelectBox options={years}
                         hasFilter={false}
                         label={"سال"}
                         className={"solid-dyna-input"}
                         value={sendData?.year.toString()}
                         onChange={(data) => setSendData({...sendData, year: data.value})}
          />
          <DynaSelectBox options={months}
                         hasFilter={false}
                         label={"ماه"}
                         className={"solid-dyna-input"}
                         value={sendData?.monthNumber.toString()}
                         onChange={(data) => setSendData({...sendData, monthNumber: data.value})}
          />
          <button className={"filter-but"} onClick={filterHandler}>فیلتر</button>
        </div>

        {componentData?.length > 0 ?
          <ul className={"GanttChartList"}>
            {componentData?.map((item, index) => (
              <li key={index} className="task-row">
                <div className='cell-box'>
                  {[...Array(32).keys()].reverse().map((day) => (
                    <div key={day} className='day-cell'
                         style={{backgroundColor: day + 1 >= item.startDate && day + 1 <= item.endDate ? item.color : ''}}
                    />
                  ))}
                </div>
                <h6 className="task-name iransans">{item.name}</h6>
              </li>
            ))}
          </ul> : <h6 className={"no-data"}>اطلاعات یافت نشد</h6>
        }
      </section>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default GanttChart;